import { put, call, takeLatest, select } from 'redux-saga/effects';
import {
  getAllPendingProposalSucessAction,
  getSinglePendingProposalSuccessAction,
  setPendingPrivateInquiryCountAction,
  setPendingPrivateInquiryIsLoadingAction,
  moderatePendingProposalSuccessAction,
  rejectPendingProposalSuccessAction,
} from './Actions';
import { push } from 'react-router-redux';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';
import { authUserIdSelector } from '../../auth/Selectors';

import { actions } from './Reducer';
import * as api from './Api';
import { func } from 'prop-types';

function* getAllPendingPrivateProposal({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    sort: 'createdAt',
    searchTerm: '',
    dir: 'asc',
    filterBy: [],
    filterCountry: '',
    filterByElementsLength: ''
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    const response = yield call(api.getAllPendingProposal, body);
    const { data } = response;
    const { content, count } = data;

    yield put(getAllPendingProposalSucessAction(content));
    yield put(setPendingPrivateInquiryCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* getSinglePendingArtisanProposal({ payload }) {
  const id = payload;
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    const response = yield call(api.getSinglePendingProposal, id);

    const { data } = response;
    yield put(getSinglePendingProposalSuccessAction(data));
    yield put(newSuccessNotificationAction('Success'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* rejectPendingArtisanProposal({ payload }) {
  const id = payload;
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));

    yield call(api.rejectPendingProposal, id);
    yield put(rejectPendingProposalSuccessAction(id));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

function* moderatePendingArtisanProposal({ payload, mode }) {
  const id = payload;
  console.log(payload);
  try {
    yield put(setPendingPrivateInquiryIsLoadingAction(true));
    const response = yield call(api.moderatePendingProposal, id);
    const { data } = response;
    yield put(moderatePendingProposalSuccessAction(id));
    yield put(newSuccessNotificationAction('Proposal Moderated'));
    yield put(push('/artisans-moderation/private-inquiry'));
    //   if (mode === 'update') {
    //   } else {

    // const response = yield call(api.moderateCreateArtisanInquiry, id);
    //   const { data } = response;
    //   yield put(moderateCreateArtisanPrivateInquirySuccessAction(id));
    //   yield put(newSuccessNotificationAction('Inquiry Moderated'));
    //   yield put(push('/artisans-moderation/private-inquiry'));

    //   }
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setPendingPrivateInquiryIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_PENDING_ARTISAN_PROPOSALS,getAllPendingPrivateProposal )
  yield takeLatest(actions.GET_SINGLE_PENDING_ARTISAN_PROPOSAL,getSinglePendingArtisanProposal )
  yield takeLatest(actions.MODERATE_PENDING_ARTISAN_PROPOSAL,moderatePendingArtisanProposal )
  yield takeLatest(actions.REJECT_PENDING_ARTISAN_PROPOSAL,rejectPendingArtisanProposal )
}
